import { render } from "./AgentsPage.vue?vue&type=template&id=e244188a&ts=true"
import script from "./AgentsPage.vue?vue&type=script&lang=ts"
export * from "./AgentsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__